<script>
    import {Link, navigate} from "svelte-routing";
    import LoadingIcon from "./LoadingIcon.svelte";
    import {_} from '../lib/i18n';

    export let analyze;
    export let identity;

    export let totalAnalyzes;
    export let nextId;
    export let prevId;

    export let currentView;
    export let params = {};
    let path = '';
    $: path = (params && params.path) ? params.path : '';


    export let photo;
    $: photo = (analyze && analyze.account) ? analyze.account.photo : '';
    export let username;
    $: username = (analyze && analyze.account) ? analyze.account.username : '';
    export let followers;
    $: followers = (analyze && analyze.account) ? analyze.account.followers_count : 0;
    export let follows;
    $: follows = (analyze && analyze.account) ? analyze.account.follows_count : 0;
    export let medias;
    $: medias = (analyze && analyze.account) ? analyze.account.media_count : 0;

    function abbreviateNumber(value) {
        var newValue = value;
        if (value >= 1000) {
            var suffixes = ["", "k", "m", "b","t"];
            var suffixNum = Math.floor( (""+value).length/3 );
            var shortValue = '';
            for (var precision = 2; precision >= 1; precision--) {
                shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
                var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
                if (dotLessShortValue.length <= 2) { break; }
            }
            if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
            newValue = shortValue+suffixes[suffixNum];
        }
        return newValue;
    }

    function gotoAddAccount() {
        navigate(`${path}/dashboard/add-account`);
    }

    function onImageError(event) {
        event.target.src = '/spy20-lk/icons/avatar-empty.svg';
    }
</script>

<section class="target-info">
    <div class="target-info__content-wrapper">
        <img src={photo} on:error={onImageError} alt="" class="target-info__avatar" />
        <div class="target-info__details-wrapper">
            <div class="target-info__name-wrapper">
                <p class="target-info__label">{$_('targetInfoBlock.targetLabel')}:</p>
                <h1 class="target-info__login">@{username}</h1>
            </div>
            <div class="target-info__stats-wrapper">
                <div class="target-info__stats-item">
                    <p class="target-info__label">{$_('targetInfoBlock.followersCountLabel')}</p>
                    <h3 class="target-info__number">
                        {#if followers !== null}
                            {abbreviateNumber(followers)}
                        {:else}
                            <div style="text-align: center">
                                <LoadingIcon show={true} width="16" height="16" />
                            </div>
                        {/if}
                    </h3>
                </div>
                <div class="target-info__stats-item">
                    <p class="target-info__label">{$_('targetInfoBlock.followsCountLabel')}</p>
                    <h3 class="target-info__number">
                        {#if follows !== null}
                            {abbreviateNumber(follows)}
                        {:else}
                            <div style="text-align: center">
                                <LoadingIcon show={true} width="16" height="16" />
                            </div>
                        {/if}
                    </h3>
                </div>
                <div class="target-info__stats-item">
                    <p class="target-info__label">{$_('targetInfoBlock.postsCountLabel')}</p>
                    <h3 class="target-info__number">
                        {#if medias !== null}
                            {abbreviateNumber(medias)}
                        {:else}
                            <div style="text-align: center">
                                <LoadingIcon show={true} width="16" height="16" />
                            </div>
                        {/if}
                    </h3>
                </div>
            </div>
        </div>
    </div>
    <div class="target-info__controls-wrapper">
        {#if totalAnalyzes > 1}
        <Link to={`${path}/dashboard/analyze/${prevId}`} class="button button_icony button_icony-24 target-info__control-btn target-info__control-btn_arrows target-info__control-btn_prev">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.625 14.25L7.08211 9.70711C6.69158 9.31658 6.69158 8.68342 7.08211 8.29289L11.625 3.75" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </Link>
        {/if}
        {#if identity.spy_has_full_payments}
        <button on:click={gotoAddAccount} class={"button button_icony button_icony-24 button_ghost target-info__control-btn target-info__control-btn_add " + ((totalAnalyzes === 1) ? 'vertical_center' : '')}>
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 20.5V19.5C4 16.7386 6.23858 14.5 9 14.5H12.75M17.5355 14.4645V18M17.5355 18V21.5355M17.5355 18H21.0711M17.5355 18H14M15 7.5C15 9.70914 13.2091 11.5 11 11.5C8.79086 11.5 7 9.70914 7 7.5C7 5.29086 8.79086 3.5 11 3.5C13.2091 3.5 15 5.29086 15 7.5Z" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span>{$_('targetInfoBlock.addNewTarget')}</span>
        </button>
        {/if}
        {#if totalAnalyzes > 1}
        <Link to={`${path}/dashboard/analyze/${nextId}`} class="button button_icony button_icony-24 target-info__control-btn target-info__control-btn_arrows target-info__control-btn_next">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.125 3.75L11.6679 8.29289C12.0584 8.68342 12.0584 9.31658 11.6679 9.70711L7.125 14.25" stroke="#161516" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </Link>
        {/if}
    </div>
</section>

<style>
    .target-info__avatar {
        border-radius: 100%;
    }
    @media (max-width: 1114px) {
        .target-info__control-btn_add.vertical_center {
            margin-top: 30px;
        }
    }
    @media (max-width: 360px) {
        .target-info {
            flex-direction: column;
        }

        .target-info__controls-wrapper {
            display: flex;
            margin-left: 0px;
            margin-top: 10px;
        }

        .target-info__control-btn {
            margin-bottom: 0px;
            margin-right: 8px;
        }

        .target-info__control-btn_add {
            width: auto;
            padding: 0 8px;
            margin: 0 10px;
        }

        .target-info__control-btn_add span {
            display: block;
        }
        .target-info__control-btn_add.vertical_center {
            margin-top: 0;
        }
    }
</style>